import { CSSProperties, FC } from "react";
import { Checkbox, Table } from "antd";
import clsx from "clsx";
import { InHouseFeasibility } from "../../../../types/IntelligenceTypes";
import styles from "./PricingModels.module.less";

const { Column } = Table;

interface InHouseFeasibilitiesProps {
    data?: InHouseFeasibility[];
    style?: CSSProperties;
}

export const InHouseFeasibilities: FC<InHouseFeasibilitiesProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                In-house vs Outsourcing feasibility
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column
                    title="Feasibility"
                    dataIndex="feasibility"
                    render={(value) => <Checkbox className={styles.check}>{value}</Checkbox>}
                    width={334}
                />
                <Column title="Costs and Benefits" dataIndex="costsAndBenefits" width={334} />
                <Column title="Resourcing Considerations" dataIndex="resourcing" />
            </Table>
        </div>
    );
};
